import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import Validator from 'validator';
import moment from 'moment';
import humanizeDuration from "humanize-duration"
import { useParams } from 'react-router-dom';
import {
    DataFieldText,
    FieldContainer,
    LabelFieldText,
} from "../components/StyledComponents/StyledComponents";
import FieldView from "../components/FormFields/FieldView";
import { DJANGO_API, FRONTEND_URL, API_KEY } from "../utils/config";
import { METHODS, RESPONSE_STATUS } from "../utils/constants";
import appContext from "../providers/app/AppContext";
import pet_cry from '../assets/images/pet_cry.png'
import logo from '../assets/images/logoPetmimo.png'
import Loading from '../components/Loading';
import download from '../assets/images/download.png'
import download_zip from '../assets/images/download_zip.png'
import Resend from '../components/Resend';
import { colors } from '../utils/colors';
import { formatBytes } from '../utils/constants';
import axios from 'axios';

const DownloadCompressedQRFile = () => {
    const app = React.useContext(appContext);
    const [qrBatchFile, setQRBatchFile] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(true)
    const [error, setError] = React.useState('')
    let { public_id } = useParams();

    React.useEffect(() => {
        app.axiosRequestApiKey(
            `${DJANGO_API}/tracking/get_compressed_qr_file/${public_id}/`,
            METHODS.GET,
            (res) => {
                console.log(res.data);
                setQRBatchFile(res.data)
                setIsLoading(false)
            },
            (err) => {
                setIsLoading(false)
                console.log(err);
                if (err.status === RESPONSE_STATUS.failure && err.message) {
                    setError(err.message);
                }
            }
        );
    }, []);

    const getName = (name) => {
        let name_split = name.split("/")
        return name ? name_split[name_split.length - 1] : (isLoading ? "Cargando archivo..." : "Archivo no encontrado") 
    }

    const handleDownloadClick = async () => {
        setIsLoading(true)
        const response = await axios.get(
            `${DJANGO_API}/tracking/download_compressed_qr_file/${public_id}/`,
            {
                headers: {
                    Authorization: 'Api-Key ' + API_KEY,
                },
                responseType: "blob",
                onDownloadProgress: (progressEvent) => {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    console.log('completed: ', percentCompleted)
                    if (percentCompleted == 100)
                        setIsLoading(false)
                },
            },
        ).then((obj) => {
            const url = URL.createObjectURL(obj.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = getName(qrBatchFile.name);
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        })
    }

    return (
        <Wraper>
            <Container style={{ alignItems: 'center' }}>
                <img height={150} src={download_zip} />
                <H2>{getName(qrBatchFile.name ? qrBatchFile.name : "")}</H2>

                {qrBatchFile.size ?
                    <LabelFieldText style={{ textAlign: 'center', maxWidth: '25rem', fontSize: '1rem' }}>
                        {formatBytes(qrBatchFile.size ? qrBatchFile.size : 0)}
                    </LabelFieldText> : ""
                }

                {isLoading ?
                    <Div style={{ display: 'flex', justifyContent: 'center' }}><Loading /></Div> :
                    qrBatchFile.name ?
                        <Button disabled={isLoading} onClick={(event) => {
                            handleDownloadClick()
                        }}>Descargar</Button>
                        : ""
                }
            </Container>
        </Wraper>
    );
};

export default DownloadCompressedQRFile;
//Código
const Wraper = styled.main`
  background-color: #F5F5F5;
  padding: 5% 3%;
  height: 100vh;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
  color: #333333;
  text-align: justify;
`
const H2 = styled.h2`
  font-weight: 530;
  text-align: center;
`
const H3 = styled.h3`
text-align: center;
`
const P = styled.p`
font-size: 0.9rem;
line-height: 1.3rem;
`

const Input = styled.input`
height: 1.8rem;
font-size: 1rem;
border: none;
padding: 10px;
border-radius: 8px;
width: auto;
height: 2.5rem;
box-shadow: 0px 0px 5px rgba(0,0,0,0.5);
`;
const Textarea = styled.textarea`
border-width: 1;
border-color: ${colors.grayExtraLigth};
padding: 10px;
border-radius: 15px;
width: auto;
resize: none;
box-shadow: 0px 0px 5px rgba(0,0,0,0.5);
`;
const Label = styled.label`
`
const Button = styled.button`
font-size: 1em;
margin: 0.2em;
text-transform: uppercase;
padding: 0.8rem;
font-size: 0.8rem;
background-color: ${colors.orangeLigth};
color: #fff;
border: none;
border-radius: 8px;
`;
const Div = styled.div`
`;

const A = styled.a`
margin-left: 0.3rem;
color: ${colors.orangeLigth}
`;